module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAAHe9q7oAAAAAXNSR0IArs4c6QAAADRJREFUCB1jiDuw15Mh9sCux4wggoGBQQbMYGRgTmMC8f4z/J0FlwIKgMATJpA0iAHCIDYAWqIT6CpVI1AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/live/calendar_tip_dot.png
// module id = jLVI
// module chunks = 1